import { useRef, useState, useCallback, useEffect } from "react";

const useOtpTimer = (initialTime = 180) => {
  const timerRef = useRef(null);
  const [timeLeft, setTimeLeftState] = useState(initialTime);

  // Helper to clear interval and nullify ref
  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  // Start the timer from a specific value (or initialTime)
  const startTimer = useCallback(
    (fromTime) => {
      clearTimer();
      const startFrom = typeof fromTime === "number" ? fromTime : initialTime;
      setTimeLeftState(startFrom);
      if (startFrom > 0) {
        timerRef.current = setInterval(() => {
          setTimeLeftState((prevTime) => {
            if (prevTime <= 1) {
              clearTimer();
              return 0;
            }
            return prevTime - 1;
          });
        }, 1000);
      }
    },
    [initialTime]
  );

  // Reset the timer
  const resetTimer = useCallback(() => {
    clearTimer();
    setTimeLeftState(initialTime);
  }, [initialTime]);

  // Set time left and restart timer from that value
  const setTimeLeft = useCallback((newTime) => {
    clearTimer();
    setTimeLeftState(newTime);
    if (typeof newTime === "number" && newTime > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeftState((prevTime) => {
          if (prevTime <= 1) {
            clearTimer();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }
  }, []);

  // Clear timer on unmount
  useEffect(() => {
    return () => clearTimer();
  }, []);

  return { timeLeft, setTimeLeft, startTimer, resetTimer };
};

export default useOtpTimer;
